import SectionHeader from "@/components/site/SectionHeader";
import Seo from "@/components/seo/Seo";
import { breadcrumbSchema } from "@/components/seo/schema";

export default function Privacy() {
  return (
    <div data-testid="page-privacy">
      <Seo
        title="Privacy Policy | Equinox Systems"
        description="How Equinox Systems collects, uses, and protects your information across quotes, applications, consultations, and payments."
        path="/privacy"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Privacy", path: "/privacy" }])]}
      />
      <section className="relative py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <SectionHeader as="h1" eyebrow="Legal" title="Privacy Policy" />
          <div className="prose prose-invert max-w-none text-gray-300 leading-relaxed space-y-5 text-sm">
            <p>
              Equinox Systems ("we", "us", "our") respects your privacy. This policy
              describes the information we collect, how we use it, and your choices.
            </p>
            <h3 className="font-display text-xl text-white">Information We Collect</h3>
            <p>
              We collect information you provide when you submit a quote request,
              book a consultation, or contact us — including name, email, phone,
              business details, and any files you choose to upload.
            </p>
            <h3 className="font-display text-xl text-white">How We Use Information</h3>
            <p>
              We use your information to respond to inquiries, deliver services,
              process payments through Stripe, and improve our offerings. We do not
              sell your data to third parties.
            </p>
            <h3 className="font-display text-xl text-white">Payments</h3>
            <p>
              Payments are processed by Stripe. We do not store full credit card
              numbers. See Stripe's policy for processor-level details.
            </p>
            <h3 className="font-display text-xl text-white">Contact</h3>
            <p>
              Questions? Email{" "}
              <a className="text-blue-400" href="mailto:Equinox@freedomcoreventures.com">
                Equinox@freedomcoreventures.com
              </a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
